import CompanyService from "../../../services/CompanyService";
import { getActionMeta } from "./agendaUtils";

/**
 * Whether the user may run the suggested action of an agenda item, using the
 * same permissions the app applies when the action starts from other screens.
 */
export function canRunAgendaAction(action: number): boolean {
  switch (getActionMeta(action).kind) {
    case "email":
      return CompanyService.canDo("newmail");
    case "whatsapp":
      return (
        CompanyService.canDo("newwhatsapp") && CompanyService.canShowWhatsApp()
      );
    case "task":
      return CompanyService.canDo("newtask");
    case "call":
    case "meeting":
    case "escalate":
      return CompanyService.canDo("newcomment");
    default:
      return false;
  }
}
